<template>
  <div>
    <el-drawer title="对话记录" :visible.sync="drawer" :direction="'rtl'" :size="'60%'" :before-close="handleClose">
      <div class="drawer-box">
        <div class="drawer-right">
          <div class="drawer-right-top">
            记录质检：<span>{{ drawerInfo.check_result_text ? drawerInfo.check_result_text : '未质检' }}</span>
          </div>
          <div class="drawer-right-bot">
            <pre class="drawer-right-pre" v-if="drawerInfo.channel != 4">{{ drawerInfo.content }}
              <p v-if="drawerInfo.check_result !== 0">{{`记录质检（质检人：${drawerInfo.check_admin_name}）  ${drawerInfo.check_at}`}}</p>
              <p class="drawer-res" v-if="drawerInfo.check_result !== 0">{{drawerInfo.check_result_text}}</p>
            </pre>
             <div v-if="drawerInfo.channel == 4">
              <div v-for="(item, index) in drawerInfo.content" :key="index" style="margin-top: 15px">
                <span style="margin-bottom: 3px; margin-right: 15px; font-size: 13px" v-if="item.from == 2">{{ item.user }}</span>
                <span style="margin-bottom: 3px; margin-right: 15px; font-size: 13px" v-if="item.from == 2">{{ item.time }}</span>
                <!-- 是客服回复的用蓝色的字体 -->
                <span style="margin-bottom: 3px; margin-right: 15px; font-size: 13px; color: #409eff" v-if="item.from != 2">{{ item.user }}</span>
                <span style="margin-bottom: 3px; margin-right: 15px; font-size: 13px; color: #409eff" v-if="item.from != 2">{{ item.time }}</span>
                <span style="margin-bottom: 3px; margin-right: 15px; font-size: 13px; color: #e80000">{{ item.revoke ? '已撤回' : '' }}</span>
                <div style="margin-top: 10px">
                  <p style="margin-bottom: 5px; margin-top: 10px; font-size: 13px" v-if="item.type == 'text' && item.from == 2">{{ item.content }}</p>
                  <p style="margin-bottom: 5px; margin-top: 10px; font-size: 13px; color: #409eff" v-if="item.type == 'text' && item.from != 2">{{ item.content }}</p>
                  <img :src="item.content" alt="" v-if="item.type == 'image'" width="500px" style="vertical-align: top; margin-bottom: 3px" />
                  <img :src="item.content" alt="" v-if="item.type == 'emotion'" width="500px" style="vertical-align: top; margin-bottom: 3px" />
                  <video :src="item.content" v-if="item.type == 'video'" controls width="500px" style="vertical-align: top; margin-bottom: 3px" />
                  <audio :src="item.content" v-if="item.type == 'voice'" controls style="vertical-align: middle; margin-bottom: 3px" />
                  <a download="文件内容" :href="item.content" v-if="item.type == 'file'">文件下载</a>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="'质检'" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog';
import { getInspectionInfo, getInspectionChatList, saveCheckResult } from '@/api/vipQualityTest';

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      drawer: false,
      drawerInfo: {},
      currentDrawerId: 0,
      dialogVisible: false,
      dialogModel: [
        {
          type: 'el-radio',
          label: '质检结果',
          prop: 'check_result',
          options: [
            { label: 1, text: '合格' },
            { label: 2, text: '不合格' },
            { label: 3, text: '提醒' }
          ],
        },
        {
          type: 'el-input-textarea',
          label: '备注',
          prop: 'remark',
        },
      ],
    };
  },
  methods: {
    // 选择账号 - 获取来访列表以及此条信息的详情
    async chooseAcc(row) {
      this.currentDrawerId = row.extension;
      // 获取此条信息的详情
      const r = await getInspectionInfo({ id: row.extension });
      this.drawerInfo = r.data.data;
      this.drawer = true;
    },
    // 切换记录
    async changeRecord(id) {
      const { data } = await getInspectionInfo({ id: id });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.currentDrawerId = id;
      this.drawerInfo = data.data;
    },
    // 关闭
    handleClose(done) {
      this.drawerInfo = {};
      this.drawerList = [];
      this.drawerTotal = 0;
      this.currentDrawerId = 0;
      done();
    },
    // 质检操作
    editRecord() {
      this.dialogVisible = true;
      this.$refs.dialog.resetForm();
      this.$refs.dialog.editForm({ id: this.currentDrawerId, check_result: this.drawerInfo.check_result, remark: this.drawerInfo.remark });
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
      this.$emit('refresh');
    },
    // 弹窗确认
    async dialogSure(form) {
      const { data } = await saveCheckResult(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.changeRecord(this.currentDrawerId);
    },
  },
};
</script>

<style>
.drawer-box {
  width: 100%;
  height: 800px;
  /* background-color: lightgreen; */
}
.drawer-left {
  width: 260px;
  height: 100%;
  /* background-color: pink; */
  border-right: 1px solid #eaeefb;
  float: left;
}
.drawer-list {
  width: 100%;
  height: 100%;
  /* background-color: lightyellow; */
  overflow-y: auto;
}
.drawer-li {
  width: 90%;
  line-height: 40px;
  text-align: center;
  border: 1px solid #eaeefb;
  cursor: pointer;
  margin: 30px auto;
  transition: all 0.1s ease-in;
}
.current-li {
  background-color: #409eff;
  color: white;
}

.drawer-right {
  width: calc(100% - 340px);
  height: 100%;
  /* background-color: lightblue; */
  padding-left: 30px;
  padding-right: 30px;
  float: left;
}
.drawer-right-top {
  line-height: 45px;
  border-bottom: 1px solid #eaeefb;
  margin-bottom: 30px;
}
.drawer-right-top > span {
  color: #409eff;
  cursor: pointer;
}
.drawer-right-bot {
  width: 100%;
  height: 80%;
  /* background-color: pink; */
  overflow-y: auto;
}
.drawer-right-pre {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
.drawer-res {
  margin-bottom: 100px;
}
@media screen and (max-height: 700px) {
  .drawer-box {
    width: 100%;
    height: 800px;
    overflow-y: auto;
    /* background-color: lightgreen; */
  }
}
</style>